import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AnalyticsProvider } from "contexts/analytics-context";
import { AppProvider } from "contexts/app-context";
import { RootLayout } from "layouts/root-layout";
import { DevTools } from "services/simulation/dev-tools";
import { AlertContainer } from "screens/alerts/alert-toast";
import { ScreenContainer } from "screens";
import { SplashScreen } from "screens/splash/splash";
import { MqttClientProvider } from "./services/mqtt-client";
import AppDownload from "./app-download";
import AppFirmwareUpdate from "./app-firmware-update";
import ScreenAutoSwitcher from "navigation/screen-auto-switcher";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/download" element={<AppDownload />} />
        <Route path="/update" element={<AppFirmwareUpdate />} />
        <Route path="*" element={<AppHelm />} />
      </Routes>
    </BrowserRouter>
  );
}

function AppHelm() {
  return (
    <MqttClientProvider>
      <AppProvider>
        <AnalyticsProvider>
          <div className="flex">
            <RootLayout>
              <SplashScreen />
              <AlertContainer />
              <ScreenContainer />
              <ScreenAutoSwitcher />
            </RootLayout>
            <DevTools show={true} />
          </div>
        </AnalyticsProvider>
      </AppProvider>
    </MqttClientProvider>
  );
}

export default App;
